import { Modal, Form, Input, Checkbox } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item
const { TextArea } = Input

function AddUserOrganizationTeam(props) {
  const { form, removeRecord, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal {...rest}>
      <Form layout="vertical">
        <FormItem label="Organization:">
          {getFieldDecorator('organization', {
            rules: [
              {
                required: true,
              }
            ]
          })(<Input />)}
        </FormItem>
        <FormItem label="User:">
          {getFieldDecorator('userIdentity', {
            rules: [
              {
                required: true,
              }
            ]
          })(<TextArea rows={7} />)}
        </FormItem>
      </Form>
    </Modal>
  )
}

export const OrganizationTeamModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(AddUserOrganizationTeam))

AddUserOrganizationTeam.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  removeRecord: PropTypes.object,
  type: PropTypes.string,
}
